const e=async(e,t,n,r,i)=>{await e.delete(`/webhooks/${t}/${n}/${r}/subscriptions/${i}`)};export{e as deleteWebhookSubscription};
//# sourceMappingURL=delete-subscription.mjs.map